import { useState } from "react";
import { Modal } from "react-bootstrap";
import { deleteCategoryById } from "../../../api/inventory";
import { useCategoryId } from "../../../utils/InventoryHooks";

export default function ModalDeleteCategories({ show, id, onClose, onSuccess }) {
  let { data } = useCategoryId({id});
  const [alert, setAlert] = useState({show: false, message: '', type: ''});
  let [loading, setLoading] = useState(false);

  const handleClose = () => {
    if (!loading) {
      setAlert({show: false, message: '', type: ''});
      onClose();
    }
  }

  const onDelete = async () => {
    setLoading(true);
    try {
      let response = await deleteCategoryById(id);
      onSuccess(`Success delete category`);
      handleClose();
    } catch (error) {
      let message = ""
      if (error.response) {
        let { data } =  error.response;
        message = data.message;
      } else {
        message = "Something Error Happened";
      }

      setAlert({show: true, message, type: 'danger'})
    }

    setLoading(false);
  }

  return(
    <Modal show={show} onHide={() => handleClose()}>
      <Modal.Header closeButton>
        <Modal.Title>Hapus Kategori</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {alert.show &&
        <div className={`alert alert-${alert.type} alert-dismissible fade show`} role="alert">
          {alert.message}
          <button type="button" className="close"  onClick={() => setAlert({show: false, message: '', type: ''})} aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      }
        <h5 className="text-gray-800">Apakah anda yakin akan menghapus data kategori "{data.name}"?</h5>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-default" onClick={() => handleClose()}>Tidak</button>
        <button className="btn btn-danger" onClick={() => onDelete()} disabled={loading}>{loading ? 'Menunggu ...' : 'Ya'}</button>
      </Modal.Footer>
    </Modal>
  )
}